import ComposeMessage from './ComposeMessage';
import RoomItem from './RoomItem';
import MessageItem from './MessageItem';
const Chat = {
    ComposeMessage,
    RoomItem,
    MessageItem,
};
export default Chat;
